// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex-row.space-between * {
  flex: 1 1;
  min-width: 75px;
}

ion-item {
  font-size: 14px;
}

.invoice-forward {
  width: 40px;
  padding: 0;
  --padding-start: 0;
  --padding-end: 0;
}

.invoice-forward.big {
  width: 120px;
}

table tr td {
  min-width: 75px;
  white-space: pre;
  line-height: 3;
}

.overflow-x-auto {
  overflow-x: auto;
}

.styled-table {
  width: 100%;
  border-collapse: collapse;
  font-family: sans-serif;
  font-size: 16px;
}

.styled-table th {
  padding: 5px 5px;
  border: 1px solid #ccc;
}

.styled-table td {
  border: 1px solid #e8e8e8;
}

.styled-table thead {
  background-color: #dad3d3;
  color: #232323;
}

/* Odd rows default */
.styled-table tbody tr:nth-child(odd) {
  background-color: #f3f3f3;
}

.styled-table tbody tr:nth-child(even) {
  background-color: #e5e5e5;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/client-invoice/components/invoice/invoice.component.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAMI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAHN;;AAQA;EACE,gBAAA;AALF;;AAWA;EACE,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;AARF;;AAWA;EACE,gBAAA;EACA,sBAAA;AARF;;AAUA;EACE,yBAAA;AAPF;;AAUA;EACE,yBAAA;EACA,cAAA;AAPF;;AAUA,qBAAA;AACA;EACE,yBAAA;AAPF;;AASA;EACE,yBAAA;AANF","sourcesContent":[".flex-row.space-between * {\n  flex: 1 1;\n  min-width: 75px;\n}\n\nion-item {\n  font-size: 14px;\n}\n\n.invoice-forward {\n  width: 40px;\n  padding: 0;\n  --padding-start: 0;\n  --padding-end: 0;\n}\n\n.invoice-forward.big {\n  width: 120px;\n}\n\ntable {\n  //overflow-x: auto;\n\n  tr {\n    td {\n      min-width: 75px;\n      white-space: pre;\n      line-height: 3;\n    }\n  }\n}\n\n.overflow-x-auto {\n  overflow-x: auto;\n}\n\n\n\n\n.styled-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: sans-serif;\n  font-size: 16px;\n}\n\n.styled-table th {\n  padding: 5px 5px;\n  border: 1px solid #ccc;\n}\n.styled-table td {\n  border: 1px solid #e8e8e8;\n}\n\n.styled-table thead {\n  background-color: #dad3d3;\n  color: #232323;\n}\n\n/* Odd rows default */\n.styled-table tbody tr:nth-child(odd) {\n  background-color: #f3f3f3;\n}\n.styled-table tbody tr:nth-child(even) {\n  background-color: #e5e5e5;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
